export default "__VITE_ASSET__BxWHx$cd__"